import { NavLink } from "react-router-dom";
import { Footer } from "./Footer";

const TABS = [
  { to: "/area", label: "Inicio", testid: "tab-inicio" },
  { to: "/academia", label: "Academia", testid: "tab-academia" },
  { to: "/medita", label: "Medita", testid: "tab-medita" },
  { to: "/comunidad", label: "Comunidad", testid: "tab-comunidad" },
  { to: "/seguimiento", label: "Seguimiento", testid: "tab-seguimiento" },
];

export const AreaLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-40 border-b border-[#E6EEFA] bg-white/90 backdrop-blur-md">
        <div className="wrap flex h-16 items-center justify-between">
          <NavLink to="/" className="flex items-center gap-2.5">
            <span className="paso-dot" />
            <span className="font-display text-lg text-[#102B5B]" style={{ fontWeight: 600 }}>
              Da el Paso
            </span>
          </NavLink>
          <span className="text-sm text-[#626B79]">Mi espacio</span>
        </div>
        <nav className="wrap -mb-px flex gap-1 overflow-x-auto pb-0" data-testid="area-tabs">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={t.testid}
              className={({ isActive }) =>
                `whitespace-nowrap border-b-2 px-4 py-3 text-base transition-colors ${
                  isActive
                    ? "border-[#275FBE] font-semibold text-[#275FBE]"
                    : "border-transparent text-[#343A46] hover:text-[#275FBE]"
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="wrap py-10 sm:py-14">{children}</main>
      <Footer />
    </div>
  );
};
